import React from 'react'
import PropTypes from 'prop-types'
import { useRouter } from '@morningtrain/react-navigation'
import classNames from 'classnames'
import { useValue } from '@morningtrain/react-resources'

function ShiftBadge ({ children, lastBadge, title, slug = null, gray, big = false, bigger = false, name, className }) {
  const _className = classNames(
    'rounded-full',
    'flex',
    'items-center',
    'justify-center',
    { 'w-6 h-6': big === false },
    { 'w-8 h-8 big': big === true },
    { 'w-12 h-12 bigger': bigger === true },
    'text-primary-900',
    'text-2xs',
    'font-medium',
    'tracking-tighter',
    lastBadge ? 'bg-gray-200' : gray ? 'bg-gray-100' : 'bg-white',
    lastBadge ? null : 'shadow-md',
    className
  )

  const router = useRouter()

  const guessedSlug = useValue(name, null)

  if (slug === null) {
    slug = guessedSlug
  }

  const iconUrl = slug ? router.url('img/badges/' + slug + '.svg') : null
  const icon = iconUrl ? <img onError={i => i.target.style.display = 'none'} src={iconUrl} alt={title}/> : null

  return (
    <div className={_className} title={title}>
      {icon}
      {children}
    </div>
  )
}

ShiftBadge.defaultProps = {
  gray: false,
  lastBadge: false
}

ShiftBadge.propTypes = {
  lastBadge: PropTypes.bool
}

export default ShiftBadge
